var _a;
import { CustomFieldType } from '../../tickets';
export var RuleActionType;
(function (RuleActionType) {
    RuleActionType[RuleActionType["TICKET_SET_LABELS"] = 101] = "TICKET_SET_LABELS";
    RuleActionType[RuleActionType["TICKET_SET_STATUS"] = 102] = "TICKET_SET_STATUS";
    RuleActionType[RuleActionType["TICKET_ASSIGN"] = 103] = "TICKET_ASSIGN";
    RuleActionType[RuleActionType["TICKET_ADD_RELATED_ARTICLES"] = 104] = "TICKET_ADD_RELATED_ARTICLES";
    RuleActionType[RuleActionType["TICKET_ADD_AGENT_REPLY"] = 105] = "TICKET_ADD_AGENT_REPLY";
    RuleActionType[RuleActionType["TICKET_REPLY_WITH_SAVED_REPLY"] = 106] = "TICKET_REPLY_WITH_SAVED_REPLY";
    RuleActionType[RuleActionType["TICKET_REPLY_WITH_ARTICLE"] = 107] = "TICKET_REPLY_WITH_ARTICLE";
    RuleActionType[RuleActionType["TICKET_DELETE"] = 108] = "TICKET_DELETE";
    RuleActionType[RuleActionType["TICKET_MARK_SPAM"] = 109] = "TICKET_MARK_SPAM";
    RuleActionType[RuleActionType["TICKET_MARK_HAM"] = 110] = "TICKET_MARK_HAM";
    RuleActionType[RuleActionType["TICKET_SET_PRIORITY"] = 111] = "TICKET_SET_PRIORITY";
    RuleActionType[RuleActionType["TICKET_SET_LANGUAGE"] = 112] = "TICKET_SET_LANGUAGE";
    RuleActionType[RuleActionType["TICKET_SET_SLA_POLICY"] = 113] = "TICKET_SET_SLA_POLICY";
    RuleActionType[RuleActionType["TICKET_ADD_CC_USERS"] = 116] = "TICKET_ADD_CC_USERS";
    RuleActionType[RuleActionType["TICKET_SET_BRAND"] = 119] = "TICKET_SET_BRAND";
    RuleActionType[RuleActionType["TICKET_SET_VALUE_TO_CUSTOM_FIELD"] = 120] = "TICKET_SET_VALUE_TO_CUSTOM_FIELD";
    RuleActionType[RuleActionType["TICKET_SET_BOOLEAN_CUSTOM_FIELD"] = 121] = "TICKET_SET_BOOLEAN_CUSTOM_FIELD";
    RuleActionType[RuleActionType["TICKET_SET_NUMBER_CUSTOM_FIELD"] = 122] = "TICKET_SET_NUMBER_CUSTOM_FIELD";
    RuleActionType[RuleActionType["TICKET_SET_TEXT_CUSTOM_FIELD"] = 123] = "TICKET_SET_TEXT_CUSTOM_FIELD";
    RuleActionType[RuleActionType["TICKET_SET_SINGLE_SELECT_CUSTOM_FIELD"] = 124] = "TICKET_SET_SINGLE_SELECT_CUSTOM_FIELD";
    RuleActionType[RuleActionType["TICKET_SET_MULTI_SELECT_CUSTOM_FIELD"] = 125] = "TICKET_SET_MULTI_SELECT_CUSTOM_FIELD";
    RuleActionType[RuleActionType["TICKET_SET_MULTI_LEVEL_CUSTOM_FIELD"] = 128] = "TICKET_SET_MULTI_LEVEL_CUSTOM_FIELD";
    RuleActionType[RuleActionType["SEND_EMAIL"] = 201] = "SEND_EMAIL";
    RuleActionType[RuleActionType["BAN_USER"] = 301] = "BAN_USER";
})(RuleActionType || (RuleActionType = {}));
export var LabelsActionTypes;
(function (LabelsActionTypes) {
    LabelsActionTypes[LabelsActionTypes["ADD"] = 1] = "ADD";
    LabelsActionTypes[LabelsActionTypes["REMOVE"] = 2] = "REMOVE";
    LabelsActionTypes[LabelsActionTypes["REPLACE"] = 3] = "REPLACE";
})(LabelsActionTypes || (LabelsActionTypes = {}));
export var TeamRecipientsTypes;
(function (TeamRecipientsTypes) {
    TeamRecipientsTypes[TeamRecipientsTypes["ALL_AGENTS"] = 1] = "ALL_AGENTS";
    TeamRecipientsTypes[TeamRecipientsTypes["ALL_ADMINS"] = 2] = "ALL_ADMINS";
    TeamRecipientsTypes[TeamRecipientsTypes["ALL"] = 3] = "ALL";
})(TeamRecipientsTypes || (TeamRecipientsTypes = {}));
export var SendEmailActionTypes;
(function (SendEmailActionTypes) {
    SendEmailActionTypes[SendEmailActionTypes["ALL_AGENTS"] = 1] = "ALL_AGENTS";
    SendEmailActionTypes[SendEmailActionTypes["ALL_ADMINS"] = 2] = "ALL_ADMINS";
    SendEmailActionTypes[SendEmailActionTypes["ALL"] = 3] = "ALL";
    SendEmailActionTypes[SendEmailActionTypes["TICKET_OWNER"] = 4] = "TICKET_OWNER";
    SendEmailActionTypes[SendEmailActionTypes["EMAILS"] = 5] = "EMAILS";
    SendEmailActionTypes[SendEmailActionTypes["AGENTS"] = 6] = "AGENTS";
    SendEmailActionTypes[SendEmailActionTypes["GROUPS"] = 7] = "GROUPS";
    SendEmailActionTypes[SendEmailActionTypes["ACCOUNT_OWNER"] = 8] = "ACCOUNT_OWNER";
})(SendEmailActionTypes || (SendEmailActionTypes = {}));
export var customFieldToRuleActionMap = (_a = {},
    _a[CustomFieldType.BOOLEAN] = RuleActionType.TICKET_SET_BOOLEAN_CUSTOM_FIELD,
    _a[CustomFieldType.TEXT] = RuleActionType.TICKET_SET_TEXT_CUSTOM_FIELD,
    _a[CustomFieldType.MULTILINE_TEXT] = RuleActionType.TICKET_SET_TEXT_CUSTOM_FIELD,
    _a[CustomFieldType.NUMBER] = RuleActionType.TICKET_SET_NUMBER_CUSTOM_FIELD,
    _a[CustomFieldType.SINGLE_SELECT] = RuleActionType.TICKET_SET_SINGLE_SELECT_CUSTOM_FIELD,
    _a[CustomFieldType.MULTI_LEVEL] = RuleActionType.TICKET_SET_MULTI_LEVEL_CUSTOM_FIELD,
    _a);
//# sourceMappingURL=rule-actions-type.enum.js.map